export const DESKTOP_BREAKPOINT = 1280;
export const TABLET_BREAKPOINT = 960;
export const TABLET_PORTRAIT_BREAKPOINT = 670;
